import { useEffect } from 'react';

import * as Sentry from '@sentry/browser';

import urls from 'src/sections/repository/urls';
import authRequest from 'src/utils/fetch';

const fetchRecommendedReviewers = async (
  workspace_slug: string,
  repo_slug: string
) => {
  const recommendedReviewersUrl = urls.api.internal.recommendedReviewers(
    workspace_slug,
    repo_slug
  );
  const reviewersResponse = await fetch(authRequest(recommendedReviewersUrl));
  if (!reviewersResponse.ok) {
    throw Error(
      `Error fetching details about recommended reviewers branch with error code ${reviewersResponse.status}`
    );
  }

  return reviewersResponse.json();
};

export const useRecommendedReviewers = (
  setRecommendedReviewers: any,
  workspace_slug: string,
  repo_slug: string
) => {
  useEffect(() => {
    if (workspace_slug && repo_slug && setRecommendedReviewers) {
      fetchRecommendedReviewers(workspace_slug, repo_slug)
        .then(result => {
          setRecommendedReviewers(result);
        })
        .catch(e => {
          Sentry.captureException(e);
        });
    }
  }, [workspace_slug, repo_slug, setRecommendedReviewers]);
};
